import { CheckCircle2, Clock, Circle } from "lucide-react";

const PILL = {
  a_jour: "bg-[#DFF3E6] text-[#145A36]",
  livre: "bg-[#DFF3E6] text-[#145A36]",
  en_retard: "bg-[#FDEBD3] text-[#8A4B00]",
  a_renouveler: "bg-[#E3EBFA] text-[#1F4396]",
  a_faire: "bg-[#EEF0EB] text-[#5B665F]",
};

export const StatusPill = ({ status, children, testId }) => (
  <span data-testid={testId} className={`pill ${PILL[status]}`}>{children}</span>
);

export const sponsorPill = (s) =>
  s.status === "en_retard" ? `${s.cp_late} en retard` : s.status === "a_renouveler" ? "À renouveler" : "À jour";

export const cpLabel = { livre: "Livré", en_retard: "En retard", a_faire: "À faire" };

const LEVEL = {
  Or: "bg-[#F6E7B8] text-[#6B4E00]",
  Argent: "bg-[#E8EAEC] text-[#3F4850]",
  Bronze: "bg-[#F3E1D3] text-[#7A4521]",
};

export const LevelBadge = ({ level, prefix = false, testId }) => (
  <span data-testid={testId} className={`pill ${LEVEL[level]}`}>{prefix ? `Partenaire ${level}` : level}</span>
);

export const ProgressBar = ({ value, total, className = "h-2", testId }) => {
  const pct = total ? Math.round((value / total) * 100) : 0;
  return (
    <div data-testid={testId} className={`w-full rounded-full bg-[#E9ECE6] overflow-hidden ${className}`}>
      <div className="h-full rounded-full bg-[#1E6B45] transition-[width] duration-500" style={{ width: `${pct}%` }} />
    </div>
  );
};

export const CpIcon = ({ status }) => {
  if (status === "livre")
    return <span className="grid place-items-center w-8 h-8 rounded-full bg-[#DFF3E6] text-[#1E6B45] shrink-0"><CheckCircle2 size={17} /></span>;
  if (status === "en_retard")
    return <span className="grid place-items-center w-8 h-8 rounded-full bg-[#FDEBD3] text-[#8A4B00] shrink-0"><Clock size={17} /></span>;
  return <span className="grid place-items-center w-8 h-8 rounded-full bg-[#EEF0EB] text-[#5B665F] shrink-0"><Circle size={17} /></span>;
};
